const API_BASE = process.env.REACT_APP_BACKEND_URL;

const menuUrl = `${API_BASE}/api/menu`;

const parseResponse = async (response) => {
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.detail || "Menu request failed");
  }
  return data;
};

export const fetchManagedMenu = async () => {
  const response = await fetch(menuUrl);
  return parseResponse(response);
};

export const saveManagedMenu = async (categories) => {
  const response = await fetch(menuUrl, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ categories }),
  });
  return parseResponse(response);
};

export const clearManagedMenu = async () => {
  const response = await fetch(menuUrl, { method: "DELETE" });
  return parseResponse(response);
};